import { type ReactNode } from 'react';
import clsx from 'clsx';
import { SupportLink } from './SupportLink';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  /**
   * Opt-in support footer. `true` renders the default "Need help? Contact
   * support" link with no subject prefill; an object passes a context-rich
   * subject (e.g. `{ subject: 'Auth callback failed' }`). Default `false` —
   * empty-but-not-error states (e.g. "No invoices yet") stay clean.
   */
  supportLink?: boolean | { subject?: string };
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  supportLink,
}: EmptyStateProps) {
  const supportSubject =
    typeof supportLink === 'object' ? supportLink.subject : undefined;
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center py-12 gap-3',
        className
      )}
    >
      {icon && <div className="text-text-dim">{icon}</div>}
      <span className="text-sm font-mono font-semibold text-text-muted tracking-[1px]">
        {title}
      </span>
      {description && (
        <span className="text-sm font-body text-text-dim text-center max-w-[260px] leading-relaxed">
          {description}
        </span>
      )}
      {action}
      {supportLink && <SupportLink variant="inline" subject={supportSubject} />}
    </div>
  );
}
